"use client";

const items = [
  "Waste Management",
  "Tank Cleaning",
  "Sludge Removal",
  "Bunker Supply",
  "Marine Survey",
  "Insurance Survey",
  "Cargo Supervision",
  "Vessel Stores",
  "MARPOL Compliant",
  "IMO Certified",
];

export default function MarqueeSection() {
  return (
    <div className="relative py-5 border-y border-white/5 overflow-hidden bg-navy-800/40">
      {/* First row: left to right */}
      <div className="flex whitespace-nowrap animate-marquee">
        {[...items, ...items, ...items, ...items]?.map((item, i) => (
          <span key={`row1-${i}`} className="inline-flex items-center gap-6 px-6">
            <span className="text-[13px] font-bold uppercase tracking-[0.25em] text-[#8BA3BC]">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-ocean-500/40 flex-shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}